
export const isStockable = (article) => article && (article.stockGoods);